
import CmpYesNoList from "./CmpYesNoList";

export default CmpYesNoList;